import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Card, Coupon } from '../interfaces/payment';
import { Address } from '../interfaces';
import { RequestsServices } from './requests.service';

export interface MpResponse<T> {
  data: T[];
  paging?: {
    total: number
  };
}

export interface PaymentResponse {
  status: string;
  coupons: Coupon[];
}

@Injectable({ providedIn: 'root' })
export class NgPaymentService {

  constructor(
    private request: RequestsServices
  ) {}

  private _injectMundipaggParams(wallet, params?) {
    return {
      mundi_access_token: wallet.code,
      customerId: wallet.customer.id,
      ...params
    };
  }

  getWallet() {
      return from(this.request.get({path: 'ticket_sales', endPoint: '/wallet-access-token'}));
  }

  sendSinglePayment(paymentData): Observable<PaymentResponse> {
    return from(this.request.post('ticket_sales', paymentData, '/saleCreditCard'));
  }

  sendPayment(paymentData): Observable<PaymentResponse> {
    return this.getWallet().pipe(
      switchMap(wallet => from(this.request.post('ticket_sales', { ...paymentData, customer_id: wallet.customer.id }, '/sale')))
    );
  }

  getCards(): Observable<MpResponse<Card>> {
    return this.getWallet().pipe(
      switchMap(wallet =>
        from(this.request.get({path: 'ticket_sales', endPoint: '/wallet-list-cards', params: this._injectMundipaggParams(wallet)}))));
  }

  createCard(card: Card): Observable<Card> {
    return this.getWallet().pipe(
      switchMap(wallet => from(this.request.post('ticket_sales', this._injectMundipaggParams(wallet, card), '/wallet-add-card')))
    );
  }

  deleteCard(cardId: string): Observable<Card> {
    return this.getWallet().pipe(
      switchMap(wallet => from(this.request.post('ticket_sales', this._injectMundipaggParams(wallet, {cardId}), '/wallet-delete-card')))
    );
  }

  getAddresses(): Observable<MpResponse<Address>> {
    return this.getWallet().pipe(
      switchMap(wallet =>
        from(this.request.get({path: 'ticket_sales', endPoint: '/wallet-list-addresses/', params: this._injectMundipaggParams(wallet)})))
    );
  }

  createAddress(address: Address): Observable<Address> {
    return this.getWallet().pipe(
      switchMap(wallet => from(this.request.post('ticket_sales', this._injectMundipaggParams(wallet, address), '/wallet-add-address')))
    );
  }

  deleteAddress(addressId: string): Observable<Address> {
    return this.getWallet().pipe(
      switchMap(wallet =>
        from(this.request.post('ticket_sales', this._injectMundipaggParams(wallet, {addressId}), '/wallet-delete-address')))
    );
  }
}
